export default __webpack_public_path__ + "static/media/quality.04576810.png";